export enum OfficeStatus {
  validFax = "valid_fax",
  optedOut = "opted_out",
  notAMedicalOffice = "not_a_medical_office",
  faxFailed = "fax_failed",
  unresponsive = "unresponsive",
  testing = "testing",
}
